/* eslint-disable max-len */
import React, {useEffect, useState, useRef} from 'react'
import {connect} from 'react-redux'

// Actions
import {storePayload} from '../actions/storePayload'

// Components
import {Icon} from '@lazarusai/forms-ui-components'
import {Document, Page, pdfjs} from 'react-pdf'

// React-PDF styles needed to remove warnings
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
import 'react-pdf/dist/esm/Page/TextLayer.css'

// Styles
import '../styles/Pdf.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function PdfRender(props) {
  const [rotations, setRotations] = useState(0)
  const [pageNumber, _setPageNumber] = useState(1)
  const [newDocPageCount, setNewDocPageCount] = useState(0)
  const [zoom, setZoom] = useState(1)
  const pageNumberRef = useRef(pageNumber)
  function setPageNumber(data) {
    _setPageNumber(data)
    pageNumberRef.current = data
  }

  const fileIndex = 0 // file index placeholder


  useEffect(() => {
    if (props.file) {
      setPageNumber(1)
      setRotations(0)
      setZoom(1)
    }
  }, [props.file])

  function onDocumentLoadSuccess(res) {
    if (res && res.numPages) {
      setNewDocPageCount(res?.numPages)
    }
  }

  return (
    <div className='render-container'>
      {props?.file?.type === 'application/pdf' && pageNumber > 1 &&
            <div
              className='arrow arrow-left'
            >
              <Icon
                icon={'arrow-circle-left-outline'}
                key={'arrow-left'}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setPageNumber(pageNumber - 1)
                }}
              />
            </div>
      }
      {props?.file?.type === 'application/pdf' && pageNumber < newDocPageCount &&
            <div
              className='arrow arrow-right'
            >
              <Icon
                icon={'arrow-circle-right-outline'}
                key={'arrow-right'}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setPageNumber(pageNumber + 1)
                }}
              />
            </div>
      }
      {/* <div className='zoom'>
        <Slider
          type={4}
          theme={'dark'}
          onChangeZoom={(e) => {
            const val = parseInt(e.target.value)
            setZoom(3 ** (val/50) / 3)
          }}
        />
      </div>
      <div className='rotate-icon'>
        <Icon
          icon={'refresh-outline'}
          key={'rotate-icon'}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
            setRotations((rotations + 1)%4)
          }}
        />
      </div> */}
      {props?.file?.type === 'application/pdf' &&
            <div className='page-number-pill'>
              <span>{pageNumber}/{newDocPageCount}</span>
            </div>
      }
      <div id='image-container'>
        {props.file &&
            <div
              id={'pdf-keyValuePairs' + fileIndex}
              style={{width: '100%'}}
            >
              <div id='pdf-main' className='pdf-main'>
                <div id='pdf-view' className='pdf-view auto-pointer-event'>
                  <Document
                    file={props.file}
                    onLoadSuccess={onDocumentLoadSuccess}
                    // onLoadError={console.error}
                  >
                    <div
                      key={`pdf-page-${pageNumber}`}
                      className={true ? 'visible' : 'invisible'}
                      // onClick={onFileClick}
                    >
                      <Page
                        pageNumber={pageNumber}
                        width={
                          document.getElementById('image-container') ?
                            document.getElementById('image-container').clientWidth * zoom :
                            0
                        }
                        onRenderSuccess={() => console.log('To do: handle render success')}
                        onLoadError={console.error}
                        rotate={rotations * 90}
                      />
                    </div>
                  </Document>
                </div>
              </div>
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  pagesData: state.userReducer.pagesData,
  dataRender: state.userReducer.dataRender,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(PdfRender)

